import React from 'react';
import PropTypes from 'prop-types';
import { MenuItem } from '@mui/material';
import { trakrefFontFamily } from '../../../../utils';
import Text from '../../../../Utils/Util_Components/Translator';

const FilterMenuItem = ({
    filterItem,
    addFilter
}) => (
    <MenuItem
        divider
        key={filterItem.label}
        onClick={() => addFilter(filterItem)}
        sx={{
            fontWeight: 400,
            fontFamily: trakrefFontFamily,
            fontSize: '.75rem',
            padding: '4px 4px 4px 8px'
        }}
    >
        <Text id={filterItem.translateId} text={filterItem.name} />
    </MenuItem>
);

FilterMenuItem.propTypes = {
    filterItem: PropTypes.object.isRequired,
    addFilter: PropTypes.func.isRequired,
};

export default FilterMenuItem;
